<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Wnioski</div>

        <p>Wnioski złożone przez klienta</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-layout row wrap class="px-1">
          <v-spacer />

          <check-permission permissions="APPLICATION.ADD">
            <v-btn color="primary" @click="showApplicationModal"> <v-icon left>mdi-plus</v-icon>Dodaj wniosek </v-btn>
          </check-permission>
        </v-layout>

        <material-table :headers="table.headers" :items="list" @details="goToDetails" />
      </v-flex>
    </v-layout>

    <application-modal :show="applicationModal" @close="closeApplicationModal" />
  </material-card>
</template>

<script>
import { ApplicationStateTranslation, ApplicationTypeTranslation, dateFilter } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import { baseFilters } from '@/utils/baseFilters';
import ApplicationModal from './modals/Application.modal';

const messages = { listError: 'Nie udało się pobrać listy wniosków.' };
// @vuese
// Wyświetlanie zakładki wniosków klienta
// @group Client-Profile
export default {
  components: { MaterialCard, MaterialTable, ApplicationModal },
  mixins: [listMixin('application', messages)],
  data() {
    return {
      applicationModal: false,
      table: {
        headers: [
          { text: 'Numer wniosku', value: 'id', link: true },
          {
            text: 'Stan',
            value: 'state',
            render: item => ApplicationStateTranslation[item.state]
          },
          { text: 'Typ', value: 'type', render: item => ApplicationTypeTranslation[item.type] },
          {
            text: 'Data złożenia',
            value: `created`,
            width: '120px',
            render: item => dateFilter(item.created)
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      profileId: state => state.client.data.profile.id
    })
  },
  methods: {
    // @vuese
    // Przejście do szczegółów wniosku
    goToDetails(application) {
      this.$router.push({ name: 'clientApplication', params: { applicationId: application.id } });
    },

    // @vuese
    // Przeładowuje listę
    reloadList(route) {
      return this.$store
        .dispatch(
          'application/list',
          this.filters({ ...baseFilters(route), profileId: this.profileId, withInactive: true }, route)
        )
        .catch(err => this.notifyError(messages.listError));
    },

    // @vuese
    // Pokazanie modala dodawania wniosku
    showApplicationModal() {
      this.applicationModal = true;
    },

    // @vuese
    // Ukrycie modala dodawania wniosku
    closeApplicationModal() {
      this.applicationModal = false;
    }
  }
};
</script>
